/* Shared, deterministic season aliases and full-scan recommendation ranking. */
(function (root) {
  'use strict';
  function normalize(value) {
    return String(value || '').trim().toLowerCase().replace(/[\s_]+/g, '-').replace(/-+/g, '-');
  }
  var aliases = {
    'aw': 'all-weather', 'all-weather': 'all-weather', 'allweather': 'all-weather',
    'all-weathers': 'all-weather', 'all-season': 'all-season', 'allseason': 'all-season',
    'all-seasons': 'all-season', '4-season': 'all-season', 'summer': 'all-season',
    'winter-studless': 'winter-studless', 'winter-non-studded': 'winter-studless',
    'winter-studdable': 'winter-studdable'
  };
  function season(type, tags) {
    var typed = aliases[normalize(type)];
    if (typed) return typed;
    var values = (tags || []).map(function (tag) { return aliases[normalize(tag)]; }).filter(Boolean);
    // AW must never disappear behind a general "4-season" merchandising tag.
    return values.includes('all-weather') ? 'all-weather' : values[0] || null;
  }
  function text(value) { return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  function rebate(record, rules, today) {
    // Ignore the shop's appended season label when matching a model named
    // "All Season"; otherwise every Firestone summer tire would qualify.
    var modelTitle = String(record.title || '').replace(/\s*[-–—]\s*(?:all[- ]season|all[- ]weather|winter[- ]studless|winter[- ]studdable)\s+tire.*$/i, '');
    var title = text(modelTitle), brand = text(record.vendor);
    var hits = (rules.programs || []).filter(function (p) {
      return today >= p.start && today <= p.end &&
        (brand === text(p.brand) || title.includes(text(p.brand))) &&
        !(p.exclude || []).some(function (model) { return title.includes(text(model)); }) &&
        (p.models === '*' || p.models.some(function (model) { return title.includes(text(model)); }));
    });
    // Never subtract an "up to" tag or invent an amount for an unlisted model.
    return hits.reduce(function (amount, hit) { return Math.max(amount, hit.cents); }, 0);
  }
  function stock(record) { return record.stock || {}; }
  function stockVerified(data) {
    return data.tntDestinationState !== 'failed' &&
      (data.tntDestinationExempt === 'true' || data.tntStockKnown === 'true');
  }
  function eligible(record) {
    var s = stock(record);
    return record.tire && Number.isSafeInteger(record.price) && record.price > 0 &&
      s.known === true && s.state === 'ready' && !s.exempt && !s.preorder && s.available >= 4;
  }
  function freeEligible(record, province) {
    var tags = (record.tags || []).map(function (tag) { return String(tag).trim().toLowerCase(); });
    return province === 'NL' && eligible(record) && stock(record).bucket === 'nl' &&
      Number.isSafeInteger(stock(record).mountPearlAvailable) && stock(record).mountPearlAvailable >= 4 &&
      tags.includes('free shipping') && tags.includes(atob('bGFjaWUtbmwtc3RvY2tlZA==')) &&
      (tags.includes(atob('X3N1cDpsYWNpZQ==')) || tags.includes(atob('bGEgY2ll')));
  }
  function choose(records, options) {
    var rules = options.rules || { programs: [], premiumBrands: [] };
    var pool = records.filter(eligible);
    var compare = function (a, b) { return a.price - b.price || a.handle.localeCompare(b.handle); };
    var value = pool.slice().sort(compare)[0] || null;
    var premium = pool.filter(function (r) {
      var title = text(r.title), vendor = text(r.vendor);
      return (rules.premiumBrands || []).some(function (brand) {
        return vendor === text(brand) || title.includes(text(brand));
      });
    }).sort(function (a, b) {
      return (a.price * 4 - rebate(a, rules, options.today)) -
        (b.price * 4 - rebate(b, rules, options.today)) || compare(a, b);
    })[0] || null;
    var free = pool.filter(function (r) { return freeEligible(r, options.province); }).sort(compare)[0] || null;
    return { premium: premium, value: value, free: free };
  }
  function restart(state) {
    state.next = state.initialUrl;
    state.expected = null;
    state.pool = [];
    state.candidates.clear(); state.seen.clear(); state.visited.clear();
    state.complete = false; state.error = false; state.renderKey = null;
    return state;
  }
  var api = { season: season, rebate: rebate, stockVerified: stockVerified, eligible: eligible, freeEligible: freeEligible, choose: choose, restart: restart };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root) root.TntTirePicks = api;
})(typeof window === 'undefined' ? null : window);

/* Full-search counts and working chips share one sequential live-stock scan.
   No loaded-page count is ever presented as a complete result total. */
(function (root) {
  'use strict';
  function words(value) {
    return String(value || '').toLowerCase().normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function stripSeasonText(query) {
    return String(query || '').replace(/(^|[\s("'])(winter[\s_-]*(?:non[\s_-]*studded|studless)|winter[\s_-]*(?:studdable|studded)|all[\s_-]*weathers?|all[\s_-]*seasons?|winter|summer)(?=$|[\s)"'])/gi, '$1 ');
  }
  function seasonFromQuery(query) {
    query = String(query || '');
    if (/\b(?:OR|NOT)\b/i.test(query)) return null;
    if (!/[a-z_]+:/i.test(query)) return intent(query).season;
    query = query.replace(/\b[a-z_]+:\s*(?:"[^"]*"|'[^']*'|[^\s()]+)/gi, ' ');
    if (/\bwinter[\s_-]*(?:non[\s_-]*studded|studless)\b/i.test(query)) return 'winter-studless';
    if (/\bwinter[\s_-]*(?:studdable|studded)\b/i.test(query)) return 'winter-studdable';
    if (/\ball[\s_-]*weathers?\b/i.test(query)) return 'all-weather';
    if (/\ball[\s_-]*seasons?\b|\bsummer\b/i.test(query)) return 'all-season';
    return /\bwinter\b/i.test(query) ? 'winter' : null;
  }
  // ---- Query understanding -------------------------------------------------
  // Every customer phrasing is reduced to one canonical intent:
  //   size (225/65R17, LT275/60R20) + season + LT / XL / load range + leftover words.
  // "2256517", "225 65 17", "22565r17", "LT2756020", "LT 275 60 r 20",
  // "snow tires", "studded", "10 ply", "light truck", "extra load" all map to
  // the shop's own types/tags. Advanced syntax (tag:, OR, NOT) is untouched.
  var PLY = { 6: 'c', 8: 'd', 10: 'e', 12: 'f', 14: 'g', 16: 'h' };
  var STOP = /(^|\s)(?:tires?|tyres?|rims?\s+and\s+tires|sets?|of|4|four|for|the|a|an|my|new|cheap|cheapest|best|price|prices|sale|deal|deals|in|on|with|and|size|sizes|wheel\s+size)(?=\s|$)/gi;
  function advanced(query) { return /[a-z_]+:/i.test(query) || /\b(?:OR|NOT)\b/.test(query); }
  // ---- Tire sizes --------------------------------------------------------
  // Metric (225/65R17, LT275/60R20, 295/75R22.5), imperial flotation
  // (33X12.50R20) and commercial / half-inch (11R22.5, 8.75R16.5, 7.50R16)
  // all reduce to one display form and one numeric tag code:
  //   225/65R17 -> 2256517   295/75R22.5 -> 29575225   33X12.50R20 -> 3312520
  //   11R22.5 -> 11225       8.75R16.5 -> 875165
  var HALF_RIMS = { '145': '14.5', '155': '15.5', '165': '16.5', '175': '17.5', '195': '19.5', '225': '22.5', '245': '24.5' };
  function sizeNum(value) { return String(Number(value)); }
  function sizeCode(value) { return sizeNum(value).replace('.', ''); }
  function sizeWidth(value) { var n = Number(value); return n % 1 ? n.toFixed(2) : String(n); }
  function sizeRim(value, min) {
    value = String(value).replace(/^(\d{2})5$/, '$1.5');
    var n = Number(value);
    return n >= (min || 12) && n <= 26 && (n % 1 === 0 || n % 1 === 0.5) ? sizeNum(n) : null;
  }
  function metricSize(prefix, w, a, rim) {
    w = Number(w); a = Number(a); rim = sizeRim(rim);
    if (!rim || w < 125 || w > 395 || w % 10 !== 5 || a < 25 || a > 95 || a % 5) return null;
    prefix = String(prefix || '').toUpperCase();
    return (prefix === 'LT' || prefix === 'ST' ? prefix : '') + w + '/' + a + 'R' + rim;
  }
  function imperialSize(d, w, rim, strict) {
    var dn = Number(d), wn = Number(w), rn = Number(rim);
    if (strict ? !(dn >= 26 && dn <= 44 && wn >= 7 && wn <= 17.5 && rn >= 14 && rn <= 26)
      : !(dn >= 16 && dn <= 48 && wn >= 5 && wn <= 20 && rn >= 8 && rn <= 26)) return null;
    if (rn % 1) return null;
    return sizeNum(dn) + 'X' + sizeWidth(wn) + 'R' + rn;
  }
  function commercialSize(w, rim) {
    var wn = Number(w), dotted = /\./.test(String(w)); rim = sizeRim(rim, 8);
    if (!rim || !(wn >= 4 && wn <= 12.5)) return null;
    if (!/\.5$/.test(rim) && !dotted) return null; // 7.50R16 yes, "10 16" no
    return (dotted ? wn.toFixed(2) : String(wn)) + 'R' + rim;
  }
  function bareSize(digits) {
    var n = digits.length, size = null;
    if (n === 7 || n === 8) size = metricSize('', digits.slice(0, 3), digits.slice(3, 5), digits.slice(5));
    if (!size && n === 7) size = imperialSize(digits.slice(0, 2), digits.slice(2, 4) + '.' + digits.slice(4, 5), digits.slice(5), true);
    if (!size && n === 8) size = imperialSize(digits.slice(0, 2), digits.slice(2, 4) + '.' + digits.slice(4, 6), digits.slice(6), true);
    if (!size && n === 5 && HALF_RIMS[digits.slice(2)]) size = commercialSize(digits.slice(0, 2), digits.slice(2));
    if (!size && n === 6 && HALF_RIMS[digits.slice(3)]) size = commercialSize(digits[0] + '.' + digits.slice(1, 3), digits.slice(3));
    return size;
  }
  function canonicalSizes(query) {
    query = String(query || '');
    // Imperial flotation: 33x12.50r20, 33X12.5R20LT, LT33x12.50-20, 33 12.50 20, 33/12.50R20.
    query = query.replace(/(^|[^a-z0-9.\/])(?:lt|st)?\s?(\d{2}(?:\.\d{1,2})?)\s*(?:"|in)?\s*(?:x|\*|\s)\s*\/?\s*(\d{1,2}(?:\.\d{1,2})?)\s*(?:lt\s*)?(?:z?r|-|\s)\s*(\d{1,2})(?:\s?lt)?(?![\d.x\/])/gi,
      function (match, lead, d, w, rim) {
        if (!/x|\*|\./i.test(match.slice(lead.length))) return match; // "33 12 20" is too ambiguous
        var size = imperialSize(d, w, rim); return size ? lead + size : match;
      });
    // Metric incl. half-inch rims: 2256517, 225 65 17, 22565r17, LT2756020, 295/75r22.5, 29575225, 205/85D14.5.
    query = query.replace(/(^|[^a-z0-9.\/])(lt|st|p)?\s?(\d{3})\s?[\/ \-]?\s?(\d{2})\s?(?:[\/ \-]|z?r|d|b)?\s?[\/ \-]?\s?(\d{2}(?:\.?5)?)(?![\d.x])/gi,
      function (match, lead, prefix, w, a, rim) {
        var size = metricSize(prefix, w, a, rim);
        return size ? lead + size : match;
      });
    // Bare imperial / commercial digits: 3312520, 33125020, 11225, 875165.
    query = query.replace(/(^|[\s(])(\d{5,8})(?=$|[\s)])/g, function (match, lead, digits) {
      var size = bareSize(digits); return size ? lead + size : match;
    });
    // Commercial / half-inch: 11r22.5, 11 22.5, 11-22.5, 11r225, 8.75r16.5, 7.50-16, 4.80-12.
    query = query.replace(/(^|[^a-z0-9.\/])(?:lt|st)?\s?(\d{1,2}(?:\.\d{1,2})?)\s*(?:r|-|\s)\s*(\d{1,2}(?:\.?5)?)(?![\d.x\/])/gi,
      function (match, lead, w, rim) {
        var size = commercialSize(w, rim); return size ? lead + size : match;
      });
    return query;
  }
  // Canonical display sizes (output of canonicalSizes) and their tag codes.
  var CANON_SIZE = /(^|[^a-z0-9.\/])(LT|ST)?(\d{3}\/\d{2}R\d{2}(?:\.5)?|\d{2}X\d{1,2}(?:\.\d{2})?R\d{1,2}|\d{1,2}(?:\.\d{2})?R\d{1,2}(?:\.5)?)(?![\d.x])/g;
  function canonicalCode(size) {
    var m;
    if ((m = size.match(/^(\d{3})\/(\d{2})R([\d.]+)$/))) return m[1] + m[2] + sizeCode(m[3]);
    if ((m = size.match(/^([\d.]+)X([\d.]+)R(\d{1,2})$/))) return sizeCode(m[1]) + sizeCode(m[2]) + m[3];
    if ((m = size.match(/^([\d.]+)R([\d.]+)$/))) return m[1].replace('.', '') + sizeCode(m[2]);
    return null;
  }
  function sizeTagQuery(query) {
    return canonicalSizes(query).replace(CANON_SIZE, function (match, lead, prefix, size) {
      var code = canonicalCode(size); return code ? lead + 'tag:' + code : match;
    });
  }
  var intentCache = new Map();
  function intent(query) {
    query = String(query || '').replace(/\s+/g, ' ').trim();
    if (intentCache.has(query)) return intentCache.get(query);
    var out = { raw: query, advanced: advanced(query), sizes: [], season: null, lt: false, xl: false, lr: null, rest: '' };
    if (out.advanced) { out.canonical = query; intentCache.set(query, out); return out; }
    var q = ' ' + canonicalSizes(query) + ' ';
    function take(re, fn) { q = q.replace(re, function () { fn.apply(null, arguments); return ' '; }); }
    take(CANON_SIZE, function (m, lead, prefix, size) {
      if (prefix === 'LT') out.lt = true;
      out.sizes.push((prefix || '') + size);
    });
    take(/\b(?:load[\s-]*range|lr)[\s-]*([c-h])\b|\b([c-h])[\s-]*(?:load(?:[\s-]*range)?|range|rated)\b/gi, function (m, a, b) { out.lr = (a || b).toLowerCase(); });
    take(/\b(6|8|10|12|14|16)[\s-]*(?:ply|pr)\b/gi, function (m, n) { out.lr = PLY[n]; out.lt = true; });
    take(/\b(?:xl|extra[\s-]*load|reinforced)\b/gi, function () { out.xl = true; });
    take(/\blight[\s-]*truck\b|(^|\s)lt(?=\s)/gi, function () { out.lt = true; });
    take(/\b(?:(?:winter|snow)[\s-]*(?:tires?|tyres?)?[\s-]*)?(?:non[\s-]*stud(?:ded|dable)?|stud[\s-]*less|no[\s-]*studs?|friction)\b/gi, function () { out.season = 'winter-studless'; });
    take(/\b(?:(?:winter|snow)[\s-]*(?:tires?|tyres?)?[\s-]*)?(?:stud(?:ded|dable|s)?)\b/gi, function () { out.season = 'winter-studdable'; });
    take(/\ball[\s-]*weathers?\b|\b3pmsf\b|(^|\s)aw(?=\s)/gi, function () { out.season = 'all-weather'; });
    take(/\ball[\s-]*seasons?\b|\b(?:4|four)[\s-]*seasons?\b|\ba\/s\b|\bsummer\b/gi, function () { out.season = 'all-season'; });
    take(/\b(?:winter|snow)s?\b/gi, function () { if (!out.season) out.season = 'winter'; });
    out.rest = q.replace(STOP, ' ').replace(/\s+/g, ' ').trim();
    var seasonText = { 'winter-studless': 'winter studless', 'winter-studdable': 'winter studdable', 'all-weather': 'all weather', 'all-season': 'all season', winter: 'winter' };
    var size = out.sizes.join(' ');
    out.canonical = [size, out.season ? seasonText[out.season] : '',
      out.lt && !/^LT/.test(size) ? 'LT' : '', out.lr ? 'LR' + out.lr.toUpperCase() : '', out.xl ? 'XL' : '', out.rest]
      .filter(Boolean).join(' ');
    intentCache.set(query, out);
    return out;
  }
  function normalize(query) { return intent(query).canonical; }
  function requiresLT(query) { return intent(query).lt; }
  // ---- Tire classification -------------------------------------------------
  // Classified from the customer-facing title first (the supplier LT tag is on
  // ~12k passenger "XL ... LR2" tires), then type, then tags.
  var TITLE_SEASON = /[-–—]\s*(all[- ]season(?:\/summer)?|all[- ]weather|winter[- ]studless|winter[- ]studdable|summer)\s+tire/i;
  function classify(record) {
    if (record.__tnt) return record.__tnt;
    var title = String(record.title || ''), upper = title.toUpperCase();
    var tags = (record.tags || []).map(function (tag) { return String(tag).trim().toLowerCase(); });
    var label = (title.match(TITLE_SEASON) || [])[1];
    // Season tag is the single source of truth (one of these four per tire);
    // the title label and product type are only fallbacks for untagged items.
    var season = ['winter-studdable', 'winter-studless', 'all-weather', 'all-season'].filter(function (s) { return tags.indexOf(s) !== -1; });
    season = season.length === 1 ? season[0] : null;
    if (season) label = null;
    if (label) {
      label = label.toLowerCase().replace(/\s+/g, '-');
      season = /^winter-studless/.test(label) ? 'winter-studless' : /^winter-studdable/.test(label) ? 'winter-studdable'
        : /^all-weather/.test(label) ? 'all-weather' : 'all-season';
    }
    if (!season && root && root.TntTirePicks) season = root.TntTirePicks.season(record.type, tags);
    var lrMatch = upper.match(/\bLR(?:LR)?([C-H])\b|\bLOAD RANGE ([C-H])\b/) || upper.match(/\b(6|8|10|12|14|16)[ -]?PLY\b/);
    var lr = lrMatch ? (lrMatch[1] && /\d/.test(lrMatch[1]) ? PLY[lrMatch[1]] : (lrMatch[1] || lrMatch[2]).toLowerCase()) : null;
    if (!lr) ['c', 'd', 'e', 'f', 'g', 'h'].some(function (r) { if (tags.indexOf('lr' + r) !== -1) { lr = r; return true; } return false; });
    var lt = /^\s*LT\s?\d/.test(upper) || /\b\d{2,3}\/\d{2,3}[A-Z]\b/.test(upper) || !!lr ||
      /\bLIGHT TRUCK\b/.test(upper);
    var xl = /\bXL\b/.test(upper) || tags.indexOf('xl') !== -1;
    var direct = tags.indexOf('direct-import') !== -1 || tags.indexOf('our stock') !== -1;
    record.__tnt = { season: season, lt: lt, xl: xl, lr: lr, direct: direct };
    return record.__tnt;
  }
  function seasonMatchesRecord(record, requested) {
    if (!requested) return true;
    var actual = classify(record).season;
    return requested === 'winter' ? actual === 'winter' || /^winter-/.test(actual || '') : actual === requested;
  }
  function plainQuery(query) {
    query = String(query || '');
    query = query.replace(/\(\s*(?:tag:)?["']?province:[a-z]+["']?\s+OR\s+(?:tag:)?["']?province:ALL["']?\s*\)/gi, ' ');
    if (/\b(?:OR|NOT)\b/i.test(query)) return null;
    query = query.replace(/\b[a-z_]+:\s*(?:"[^"]*"|'[^']*'|[^\s()]+)/gi, ' ');
    query = canonicalSizes(query).replace(CANON_SIZE, '$1 ');
    query = query.replace(/(^|[\s(])\d{5,8}(?=$|[\s)])/g, ' ');
    query = stripSeasonText(query).replace(/\bAND\b/gi, ' ');
    return words(intent(query).rest.replace(CANON_SIZE, '$1 '));
  }
  function vendorForQuery(query, vendors) {
    var plain = plainQuery(query);
    if (!plain) return null;
    var matches = Array.from(new Set(vendors)).filter(function (vendor) {
      var name = words(vendor);
      return name && (' ' + plain + ' ').indexOf(' ' + name + ' ') !== -1;
    });
    return matches.length === 1 ? matches[0] : null;
  }
  function sizeCodes(value, bare) {
    // Titles and queries in any supplier spelling (LT 33X/12.5R20,
    // 33x12.50R22LT, 205/85D14.5, 11R22.5 16P) reduce to the same tag code.
    value = String(value || '').toLowerCase();
    var codes = [], match;
    var flotation = /(?:^|[^a-z0-9.\/])(?:lt|st)?\s?(\d{2}(?:\.\d{1,2})?)\s*(?:"|in)?\s*(?:x\s*\/?|\/)\s*(\d{1,2}(?:\.\d{1,2})?)\s*(?:lt\s*)?(?:z?r|-)\s*(\d{1,2})(?![\d.])/g;
    while ((match = flotation.exec(value))) {
      if (imperialSize(match[1], match[2], match[3])) codes.push(sizeCode(match[1]) + sizeCode(match[2]) + match[3]);
    }
    var metric = /(?:^|[^a-z0-9.\/])(?:lt|st|p|t)?\s?(\d{3})\s*\/\s*(\d{2,3})\s*(?:z?r|d|b|-)\s*(\d{2}(?:\.5)?)(?![\d.])/g;
    while ((match = metric.exec(value))) codes.push(String(Number(match[1])) + String(Number(match[2])) + sizeCode(match[3]));
    var commercial = /(?:^|[^a-z0-9.\/])(?:lt|st)?\s?(\d{1,2}(?:\.\d{1,2})?)\s*(?:r|-)\s*(\d{1,2}(?:\.5)?)(?![\d.x\/])/g;
    while ((match = commercial.exec(value))) {
      var cs = commercialSize(match[1], match[2]); if (cs) codes.push(canonicalCode(cs));
    }
    if (bare) {
      var numeric = /(?:^|[\s(:])(\d{5,8})(?=$|[\s)])/g;
      while ((match = numeric.exec(value))) codes.push(match[1]);
    }
    return codes;
  }
  function sizeMatchesTitle(title, query) {
    var wanted = sizeCodes(query, true);
    if (!wanted.length) return !/\d{2,4}\s*\/\s*\d|\d{2,3}(?:\.\d+)?\s*x\s*\d/i.test(String(query || ''));
    var actual = sizeCodes(title, false);
    return wanted.some(function (code) { return actual.includes(code); });
  }
  function candidateText(query) {
    // For an unstructured size+model/unknown-brand query, search the text
    // first and enforce size locally. Otherwise a nonexistent word still
    // returns every tire in the size and needlessly scans the whole catalog.
    if (/[a-z_]+:/i.test(query) || !sizeCodes(query, true).length) return null;
    return plainQuery(query) || null;
  }
  function numericSizeCodes(query) {
    return Array.from(new Set(sizeCodes(query, true).filter(function (code) { return /^\d{5,8}$/.test(code); })));
  }
  function matchesSizeTags(record, query) {
    var codes = numericSizeCodes(query);
    if (!codes.length) return true;
    var tags = (record.tags || []).map(function (tag) { return String(tag).trim().replace(/^tag:/i, ''); });
    return codes.some(function (code) { return tags.includes(code); });
  }
  function textMatches(record, query) {
    // Candidate search is fuzzy. Ordinary query terms must all match, but
    // advanced OR/NOT expressions retain Shopify's native interpretation.
    var plain = plainQuery(query);
    if (plain === null) return true;
    var terms = plain.split(' ').filter(Boolean);
    var haystack = words([record.title, record.vendor].concat(record.tags || []).join(' '));
    var tokens = haystack.split(' '), compact = haystack.replace(/ /g, '');
    return terms.every(function (term, index) {
      return tokens.some(function (token) {
        return token === term || (index === terms.length - 1 && token.indexOf(term) === 0);
      }) || (term.length >= 5 && compact.indexOf(term) !== -1);
    });
  }
  var api = { intent: intent, classify: classify, normalize: normalize, requiresLT: requiresLT, textMatches: textMatches, vendorForQuery: vendorForQuery, sizeMatchesTitle: sizeMatchesTitle, candidateText: candidateText,
    hasSize: function (query) { return sizeCodes(query, true).length > 0; },
    numericSizeCodes: numericSizeCodes, matchesSizeTags: matchesSizeTags, canonicalSizes: canonicalSizes, sizeTagQuery: sizeTagQuery, sizeCodes: sizeCodes,
    stripSeasonText: stripSeasonText, seasonFromQuery: seasonFromQuery, seasonMatchesRecord: seasonMatchesRecord };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root) root.TntSearchQuery = api;
})(typeof window === 'undefined' ? null : window);
(function () {
  'use strict';
  if (!/\/search\/?$/.test(location.pathname)) return;
  // Prevent a second integrity controller from erasing this verified grid.
  window.__tntQuickResultsOwnGrid = true;
  var active, timer, cache = new Map(), vendorCache = new Map(), controls;
  var queryTextMemo = { href: null, value: '' };
  function queryText() {
    if (queryTextMemo.href !== location.href) {
      queryTextMemo = { href: location.href, value: window.TntSearchQuery.normalize(new URL(location.href).searchParams.get('q') || '') };
    }
    return queryTextMemo.value;
  }
  // Chip taps must be instant: the query/price/size part of a match never
  // changes when a chip is pressed, so compute it once per record per query.
  function queryMatchKey() {
    var params = new URL(location.href).searchParams;
    return [queryText(), params.get('filter.v.price.gte'), params.get('filter.v.price.lte'), params.get('filter.v.availability')].join('|');
  }
  (function canonicalizeQuery() {
    var url = new URL(location.href), raw = url.searchParams.get('q');
    if (raw === null) return;
    var canon = window.TntSearchQuery.normalize(raw);
    if (canon === raw) return;
    url.searchParams.set('q', canon); history.replaceState(history.state, '', url.href);
    document.querySelectorAll('input[name="q"]').forEach(function (input) { if (input.value === raw) input.value = canon; });
  })();
  var titleSuffix = (document.title.match(/\s[\u2013\u2014]\s*(.+)$/) || [])[1] || '';
  var seasons = ['all-season', 'all-weather', 'winter-studless', 'winter-studdable'];
  var labels = ['All-season', 'All-weather', 'Winter — non-studded', 'Winter — studdable'];
  var toggles = [
    ['stock', '4+ in stock'], ['nl', 'Ships from Newfoundland'],
    ['direct', 'Direct import tires'], ['lt', 'Light truck (LT)'],
    ['lrc', 'Load range C (6-ply)'], ['lrd', 'Load range D (8-ply)'],
    ['lre', 'Load range E (10-ply)'], ['lrf', 'Load range F (12-ply)'], ['xl', 'Extra load (XL)']
  ];
  var params = new URL(location.href).searchParams;
  var requestedSeason = params.get('tnt_season');
  var fromQuery = window.TntSearchQuery.seasonFromQuery(queryText());
  var filters = { season: seasons.concat(['winter']).includes(requestedSeason) ? requestedSeason : requestedSeason === 'all' ? null : fromQuery };
  toggles.forEach(function (entry) { filters[entry[0]] = params.get('tnt_' + entry[0]) === '1'; });
  (function applyIntent() {
    var wish = window.TntSearchQuery.intent(queryText());
    if (wish.lt && !params.has('tnt_lt')) filters.lt = true;
    if (wish.xl && !params.has('tnt_xl')) filters.xl = true;
    if (wish.lr && ['c', 'd', 'e', 'f'].indexOf(wish.lr) !== -1 && !params.has('tnt_lr' + wish.lr)) filters['lr' + wish.lr] = true;
  })();
  var names = { NL: 'Newfoundland', NS: 'Nova Scotia', NB: 'New Brunswick', PE: 'Prince Edward Island',
    QC: 'Quebec', ON: 'Ontario', MB: 'Manitoba', SK: 'Saskatchewan', AB: 'Alberta', BC: 'British Columbia' };
  function grid() {
    var wrapper = document.getElementById('product-grid');
    return wrapper && (wrapper.matches('ul,ol') ? wrapper : wrapper.querySelector('ul.product-grid,ol.product-grid'));
  }
  function current(state) { return active === state && state.grid.isConnected; }
  function queryURL() {
    var url = new URL(location.href);
    url.searchParams.delete('page'); url.searchParams.delete('province');
    Array.from(url.searchParams.keys()).forEach(function (key) { if (key.indexOf('tnt_') === 0) url.searchParams.delete(key); });
    var q = window.TntSearchQuery.normalize(url.searchParams.get('q') || '');
    if (!url.searchParams.has('filter.p.vendor')) {
      // Use actual Shopify facet values, not an invented brand list. Cache the
      // inference so facet DOM replacement cannot start/stop the same scan.
      if (!vendorCache.has(q)) {
        var vendors = Array.from(document.querySelectorAll('input[name="filter.p.vendor"]')).map(function (input) { return input.value; });
        if (vendors.length) vendorCache.set(q, window.TntSearchQuery.vendorForQuery(q, vendors));
      }
      var vendor = vendorCache.get(q);
      if (vendor) url.searchParams.set('filter.p.vendor', vendor);
    }
    var textCandidate = !url.searchParams.has('filter.p.vendor') && window.TntSearchQuery.candidateText(q);
    q = q.replace(/\(\s*(?:tag:)?["']?province:[a-z]+["']?\s+OR\s+(?:tag:)?["']?province:ALL["']?\s*\)/gi, ' ');
    q = q.replace(/\b(?:tag:)?["']?province:[a-z]+["']?/gi, ' ');
    if (window.TntSearchQuery.hasSize(q)) q = window.TntSearchQuery.stripSeasonText(q);
    // Every size format becomes its numeric tag. LT is enforced locally
    // (tag OR title prefix): only some LT tires carry the LT tag.
    q = window.TntSearchQuery.sizeTagQuery(q);
    q = q.replace(/(^|[\s(])(\d{6,8})(?=$|[\s)])/g, '$1tag:$2');
    url.searchParams.set('q', textCandidate || q.trim()); url.searchParams.set('type', 'product');
    // Relevance ties are not a stable traversal of Shopify's fuzzy candidates.
    // Use the store's existing default price order explicitly on every page.
    if (!url.searchParams.get('sort_by')) url.searchParams.set('sort_by', 'price-ascending');
    var codes = window.TntSearchQuery.numericSizeCodes(q);
    var advanced = q.replace(/\btag:\s*\d{5,8}\b/gi, '');
    if (codes.length === 1 && !/[a-z_]+:/i.test(advanced) && !/\b(?:OR|NOT)\b/i.test(advanced)) {
      // Native tag routing bounds metadata to the numeric size on the server.
      // The customer's visible page stays /search.
      url.pathname = '/collections/all/' + codes[0];
      url.searchParams.set('tnt_size_data', '2');
      ['q', 'type', 'options', 'options[prefix]', 'options[unavailable_products]'].forEach(function (key) { url.searchParams.delete(key); });
      if (url.searchParams.get('sort_by') === 'relevance') url.searchParams.set('sort_by', 'best-selling');
    } else if (url.searchParams.getAll('filter.p.vendor').length === 1 &&
        !/[a-z_]+:/i.test(q) && !/\b(?:OR|NOT)\b/i.test(q)) {
      // Brand searches must not traverse the inconsistent search index.
      // Native vendor facets bound the candidate set; model/season stays local.
      url.pathname = '/collections/vendors';
      var selectedVendor = url.searchParams.get('filter.p.vendor');
      ['type', 'options', 'options[prefix]', 'options[unavailable_products]'].forEach(function (key) { url.searchParams.delete(key); });
      url.searchParams.set('q', selectedVendor);
      url.searchParams.delete('filter.p.vendor');
      if (url.searchParams.get('sort_by') === 'relevance') url.searchParams.set('sort_by', 'best-selling');
      url.searchParams.set('tnt_vendor_data', '1');
    }
    url.searchParams.set('view', url.pathname === '/collections/vendors' ? 'tnt-vendor-results'
      : url.pathname.indexOf('/collections/all/') === 0 ? 'tnt-size-results' : 'tnt-results');
    return url;
  }
  function syncLinks() {
    var province = window.TntProvinceStock && window.TntProvinceStock.selectedProvince();
    if (!province) return;
    var url = new URL(location.href);
    url.searchParams.set('province', province); url.searchParams.set('type', 'product');
    if (!url.searchParams.get('sort_by')) {
      url.searchParams.set('sort_by', 'price-ascending');
      document.querySelectorAll('#SortBy, #SortBy-mobile').forEach(function (select) {
        select.value = 'price-ascending';
      });
    }
    if (url.href !== location.href) history.replaceState(history.state, '', url.href);
    var values = { province: province, type: 'product', tnt_season: filters.season || 'all' };
    toggles.forEach(function (entry) { if (filters[entry[0]]) values['tnt_' + entry[0]] = '1'; });
    document.querySelectorAll('facet-filters-form form, #FacetSortForm, #FacetSortDrawerForm').forEach(function (form) {
      form.querySelectorAll('[data-tnt-search-param]').forEach(function (input) { if (!(input.name in values)) input.remove(); });
      Object.keys(values).forEach(function (name) {
        var input = form.querySelector('input[name="' + name + '"]');
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; input.dataset.tntSearchParam = 'true'; form.appendChild(input); }
        if (input.value !== values[name]) input.value = values[name];
      });
    });
  }
  function saveFilters() {
    var url = new URL(location.href);
    url.searchParams.set('tnt_season', filters.season || 'all');
    toggles.forEach(function (entry) {
      if (filters[entry[0]]) url.searchParams.set('tnt_' + entry[0], '1');
      else url.searchParams.delete('tnt_' + entry[0]);
    });
    history.replaceState(history.state, '', url.href);
    syncLinks();
  }
  function sortTo(value) {
    syncLinks();
    var select = document.querySelector('#SortBy, #SortBy-mobile');
    if (select) { select.value = value; select.dispatchEvent(new Event('input', { bubbles: true })); }
    else { var url = new URL(location.href); url.searchParams.set('sort_by', value); location.assign(url.href); }
  }
  // The theme's compact filter rows (Tire season / Filter results / Load range
  // & ply / Sort by) are the only chip set. Re-bind them to this controller
  // (cloning drops any listeners from the retired inline controller).
  function adoptLegacy() {
    var season = document.getElementById('tnt-season-filters'), quick = document.getElementById('tnt-quick-filters');
    var more = document.getElementById('tnt-more-filters'), sort = document.getElementById('tnt-sort-control');
    if (!season || !quick) return false;
    var fresh = function (node) { var copy = node.cloneNode(true); node.replaceWith(copy); return copy; };
    var root = season.parentElement;
    season.querySelectorAll('[data-tnt-season]').forEach(function (old) {
      var b = fresh(old), key = b.getAttribute('data-tnt-season');
      b.dataset.tntChip = key; b.dataset.tntChipKind = 'season';
      b.addEventListener('click', function () { filters.season = filters.season === key ? null : key; changed(); });
    });
    root.querySelectorAll('[data-tnt-filter]').forEach(function (old) {
      var raw = old.getAttribute('data-tnt-filter'), b = fresh(old);
      if (raw === 'sort-lth') {
        b.dataset.tntPriceSort = 'true';
        b.addEventListener('click', function () {
          sortTo(new URL(location.href).searchParams.get('sort_by') === 'price-ascending' ? 'relevance' : 'price-ascending');
        });
        return;
      }
      var key = raw === 'direct-import' ? 'direct' : raw;
      b.dataset.tntChip = key; b.dataset.tntChipKind = 'toggle';
      b.addEventListener('click', function () { filters[key] = !filters[key]; changed(); });
    });
    var clear = document.getElementById('tnt-filter-clear');
    if (clear) {
      clear = fresh(clear); clear.dataset.tntClear = 'true';
      clear.addEventListener('click', function () {
        filters.season = null; toggles.forEach(function (entry) { filters[entry[0]] = false; }); changed();
      });
    }
    [season, quick, more, sort].forEach(function (node) { if (node) { node.hidden = false; node.style.display = ''; } });
    if (more && ['lrc', 'lrd', 'lre', 'lrf', 'xl'].some(function (k) { return filters[k]; })) more.open = true;
    var stray = document.getElementById('tnt-search-chips'); if (stray) stray.remove();
    controls = root; updateChips();
    return !!(controls.querySelector('[data-tnt-clear]') && controls.querySelector('[data-tnt-price-sort]'));
  }
  function mountChips() {
    if (controls && controls.isConnected) return;
    if (adoptLegacy()) return;
    var anchor = document.querySelector('.template-search__search');
    if (!anchor) return;
    controls = document.createElement('div'); controls.id = 'tnt-search-chips';
    controls.className = 'page-width'; controls.setAttribute('aria-label', 'Quick product filters');
    var style = document.createElement('style');
    style.textContent = '#tnt-search-chips{margin:2rem auto;text-align:center}#tnt-search-chips .tnt-chip-row{display:flex;flex-wrap:wrap;justify-content:center;gap:.6rem;margin:.9rem 0}#tnt-search-chips button{padding:.65rem 1.1rem;border:1px solid #80938f;border-radius:999px;background:#f1f5f4;color:#17332f;font:inherit;cursor:pointer}#tnt-search-chips button[aria-pressed="true"]{background:#154e49;color:white;border-color:#154e49;font-weight:700}#tnt-search-chips button:focus-visible{outline:3px solid #1670c5;outline-offset:3px}#tnt-search-chips .tnt-season-row button{background:#e4edf1}#tnt-search-chips .tnt-season-row button[aria-pressed="true"]{background:#184563;color:white}';
    style.textContent += '.tnt-destination-pagination [hidden],#tnt-sort-control[hidden],#tnt-size-integrity-loading[hidden]{display:none!important}';
    controls.appendChild(style);
    function row(title, choices, kind) {
      var group = document.createElement('div'); group.className = 'tnt-chip-row' + (kind === 'season' ? ' tnt-season-row' : '');
      group.setAttribute('role', 'group'); group.setAttribute('aria-label', title);
      choices.forEach(function (entry) {
        var button = document.createElement('button'); button.type = 'button'; button.textContent = entry[1];
        button.dataset.tntChip = entry[0]; button.dataset.tntChipKind = kind; button.setAttribute('aria-pressed', 'false');
        button.addEventListener('click', function () {
          if (kind === 'season') filters.season = filters.season === entry[0] ? null : entry[0];
          else filters[entry[0]] = !filters[entry[0]];
          changed();
        });
        group.appendChild(button);
      }); controls.appendChild(group);
    }
    row('Tire season', seasons.map(function (season, i) { return [season, labels[i]]; }), 'season');
    row('Filter results', toggles, 'toggle');
    var clear = document.createElement('button'); clear.type = 'button'; clear.textContent = 'Clear filters'; clear.dataset.tntClear = 'true';
    clear.addEventListener('click', function () {
      filters.season = null; toggles.forEach(function (entry) { filters[entry[0]] = false; }); changed();
    });
    controls.appendChild(clear); anchor.after(controls);
    ['tnt-quick-filters', 'tnt-season-filters', 'tnt-sort-control', 'tnt-size-integrity-loading'].forEach(function (id) {
      var legacy = document.getElementById(id);
      if (legacy) { legacy.hidden = true; legacy.style.display = 'none'; }
    });
    var price = document.createElement('button'); price.type = 'button'; price.textContent = 'Price: low to high'; price.dataset.tntPriceSort = 'true';
    price.addEventListener('click', function () {
      var value = new URL(location.href).searchParams.get('sort_by') === 'price-ascending' ? 'relevance' : 'price-ascending';
      sortTo(value);
    });
    controls.appendChild(price);
    updateChips();
  }
  function updateChips() {
    if (!controls) return;
    controls.querySelectorAll('[data-tnt-chip]').forEach(function (button) {
      var on = button.dataset.tntChipKind === 'season' ? filters.season === button.dataset.tntChip : !!filters[button.dataset.tntChip];
      button.setAttribute('aria-pressed', String(on));
    });
    controls.querySelector('[data-tnt-clear]').hidden = !filters.season && !toggles.some(function (entry) { return filters[entry[0]]; });
    controls.querySelector('[data-tnt-price-sort]').setAttribute('aria-pressed', String(new URL(location.href).searchParams.get('sort_by') === 'price-ascending'));
  }
  // Each chip shows how many results it would leave; zero-result chips are
  // disabled so a tap can never empty the grid. Counts appear once the scan ends.
  function chipCounts(state) {
    if (!controls) return;
    var saved = Object.assign({}, filters);
    controls.querySelectorAll('[data-tnt-chip]').forEach(function (button) {
      if (!button.dataset.label) button.dataset.label = button.textContent;
      var key = button.dataset.tntChip, isSeason = button.dataset.tntChipKind === 'season';
      var on = isSeason ? filters.season === key : !!filters[key];
      if (!state.complete || state.error || on) { button.textContent = button.dataset.label; button.disabled = false; button.style.opacity = ''; return; }
      if (isSeason) filters.season = key; else filters[key] = true;
      var n = state.pool.filter(matches).length;
      Object.keys(filters).forEach(function (k) { filters[k] = saved[k]; });
      button.textContent = button.dataset.label + ' (' + n + ')';
      button.disabled = n === 0; button.style.opacity = n === 0 ? '.45' : '';
    });
    Object.keys(saved).forEach(function (k) { filters[k] = saved[k]; });
  }
  function changed() {
    saveFilters(); updateChips();
    if (active) {
      active.priorityDone = !!active.complete || !(active.cands || []).some(function (r) { return !r._done && staticMatch(r); });
      active.target = 24; active.renderKey = null; render(active);
    }
  }
  function matchesQuery(record) {
    // Sold-out alternatives box: honour Shopify price/in-stock filter params, which the
    // numeric-size tag route cannot apply on the server.
    var tntFilterParams = new URL(location.href).searchParams;
    var tntMin = parseFloat(tntFilterParams.get('filter.v.price.gte')), tntMax = parseFloat(tntFilterParams.get('filter.v.price.lte'));
    if (isFinite(tntMin) && record.price < Math.round(tntMin * 100)) return false;
    if (isFinite(tntMax) && record.price > Math.round(tntMax * 100)) return false;
    if (tntFilterParams.get('filter.v.availability') === '1' && record.available === false) return false;
    if (!window.TntSearchQuery.matchesSizeTags(record, queryText())) return false;
    if (!window.TntSearchQuery.textMatches(record, queryText())) return false;
    if (window.TntSearchIntegrity && !window.TntSearchIntegrity.matchesItem(record,
      window.TntSearchIntegrity.parseConstraint(queryText()))) return false;
    return true;
  }
  var matchKeyMemo = { href: null, key: '' };
  function shown(state) { return !!(state.complete || state.priorityDone); }
  // Everything except the stock-dependent chips; used to decide which tires to
  // stock-check first (the pressed chips' tires, before the rest of the size).
  function staticMatch(record) { return matches(record, true); }
  function matches(record, ignoreStock) {
    // Array.filter passes the index as the 2nd argument; only an explicit true skips stock chips.
    ignoreStock = ignoreStock === true;
    if (matchKeyMemo.href !== location.href) matchKeyMemo = { href: location.href, key: queryMatchKey() };
    if (record._mqKey !== matchKeyMemo.key) { record._mq = matchesQuery(record); record._mqKey = matchKeyMemo.key; }
    if (!record._mq) return false;
    var card = record._card || (record._card = record.node.querySelector('.card-wrapper'));
    var info = record._info || (record._info = window.TntSearchQuery.classify(record));
    if (!window.TntSearchQuery.seasonMatchesRecord(record, filters.season)) return false;
    if (!ignoreStock && filters.stock && !(Number(card.dataset.tntStockQty) >= 4)) return false;
    if (!ignoreStock && filters.nl && !['nl', 'our_stock'].includes(card.dataset.tntStockBucket)) return false;
    if (filters.direct && !info.direct) return false;
    if (filters.lt && !info.lt) return false;
    if (filters.xl && !info.xl) return false;
    return ['c', 'd', 'e', 'f'].every(function (range) { return !filters['lr' + range] || info.lr === range; });
  }

  function renderPicks(state, matching) {
    var row = document.getElementById('tnt-verified-picks');
    if (!row) return;
    var constraint = window.TntSearchIntegrity &&
      window.TntSearchIntegrity.parseConstraint(queryText());
    var exact = constraint && constraint.constrained && !constraint.invalid;
    var eligible = matching.filter(function (record) {
      return exact && window.TntSearchIntegrity.matchesItem(record, constraint);
    }).map(function (record) {
      var card = record.node.querySelector('.card-wrapper');
      return Object.assign({}, record, { stock: {
        known: card.dataset.tntStockKnown === 'true',
        state: card.dataset.tntDestinationState,
        exempt: card.dataset.tntDestinationExempt === 'true',
        preorder: card.dataset.tntStockPreorder === 'true' || record.tags.includes('preorder'),
        available: Number(card.dataset.tntStockQty),
        mountPearlAvailable: card.dataset.tntMountPearlAvailable === '' ? null : Number(card.dataset.tntMountPearlAvailable),
        bucket: card.dataset.tntStockBucket
      } });
    });
    var today = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/St_Johns', year: 'numeric', month: '2-digit', day: '2-digit'
    }).format(new Date());
    var ready = shown(state) && !state.error && !state.limited && !state.stockUnknown;
    var mountPearlVerified = eligible.length === 0 || eligible.every(function (record) {
      return Number.isSafeInteger(record.stock.mountPearlAvailable);
    });
    var picks = ready ? window.TntTirePicks.choose(eligible, {
      province: state.province, today: today, rules: state.rules || { programs: [], premiumBrands: [] }
    }) : {};
    var signature = JSON.stringify([state.province, filters, ready, state.error, state.limited, !!state.partial, !!state.stockUnknown, !!state.rules, state.rulesError, exact, mountPearlVerified,
      ['premium', 'value', 'free'].map(function (tier) { return picks[tier] && [picks[tier].handle, picks[tier].price]; })]);
    if (row.dataset.renderKey === signature) return;
    row.dataset.renderKey = signature;
    var headings = { premium: 'Premium Pick', value: 'Best Value', free: 'Free Newfoundland Shipping Pick' };
    var subtitles = { premium: 'Lowest-priced premium set after listed eligible rebates',
      value: 'Lowest-priced matching set before rebates',
      free: 'Eligible set stocked at the Mount Pearl warehouse' };
    function add(parent, tag, text, className) {
      var el = document.createElement(tag); el.textContent = text;
      if (className) el.className = className;
      parent.appendChild(el); return el;
    }
    ['premium', 'value', 'free'].forEach(function (tier) {
      var box = row.querySelector('[data-tier="' + tier + '"]');
      box.replaceChildren();
      add(box, 'h2', headings[tier], 'tnt-spotlight-badge');
      add(box, 'p', subtitles[tier], 'tnt-spotlight-subtitle');
      var unavailable = !exact ? 'Choose an exact tire size to see this pick.'
        : state.stockUnknown ? 'Live stock is briefly unavailable, so picks are paused. All matching tires are listed below.'
          : state.error || state.partial ? 'Recommendations could not be verified. Retry loading results.'
        : state.limited ? 'Narrow the search with a tire size or brand to verify this pick.'
        : !ready ? 'Checking all matching products and live stock…'
        : tier === 'free' && state.province !== 'NL' ? 'This pick is for Newfoundland island delivery. Choose Newfoundland to check availability.'
        : tier === 'free' && !mountPearlVerified ? 'Exact Mount Pearl stock verification is not available yet. Please try again later.'
        : tier === 'premium' && !state.rules ? 'Premium rebates could not be verified. Try reloading this page.'
        : !picks[tier] ? tier === 'free' ? 'No qualifying Mount Pearl set is currently available for this size and season.'
          : 'No qualifying set is currently available for this size and season.'
        : null;
      if (unavailable) { add(box, 'p', unavailable); return; }
      var item = picks[tier];
      if (item.image) {
        var wrap = document.createElement('div'); wrap.className = 'tnt-spotlight-image-wrap';
        var img = document.createElement('img'); img.src = item.image; img.alt = item.title;
        img.loading = 'lazy'; img.width = 300; img.height = 300; wrap.appendChild(img); box.appendChild(wrap);
      }
      add(box, 'h3', item.title, 'tnt-spotlight-title');
      var money = function (cents) { return new Intl.NumberFormat('en-CA', {
        style: 'currency', currency: item.currency || 'CAD'
      }).format(cents / 100); };
      add(box, 'p', money(item.price) + ' CAD each', 'tnt-spotlight-price');
      add(box, 'p', 'Set of 4: ' + money(item.price * 4) + ' before tax and fees', 'tnt-spotlight-set4');
      var amount = state.rules ? window.TntTirePicks.rebate(item, state.rules, today) : 0;
      if (amount > 0) {
        add(box, 'p', 'Estimated after rebate: ' + money(item.price * 4 - amount) + ' for 4');
        var terms = add(box, 'a', money(amount) + ' manufacturer rebate. Eligible purchase and installation terms apply; not deducted at checkout.');
        terms.href = '/pages/rebates'; terms.style.cssText = 'font-size:1.2rem;line-height:1.5;margin-bottom:1rem';
      } else if (tier === 'premium') {
        add(box, 'p', 'No listed model-specific rebate deducted.');
      }
      if (tier === 'free') add(box, 'p', 'Free shipping on 4 to eligible Newfoundland island addresses. Checkout confirms your address.');
      var link = add(box, 'a', 'View tire', 'tnt-spotlight-link');
      var url = new URL('/products/' + encodeURIComponent(item.handle), location.origin);
      if (item.variantId) url.searchParams.set('variant', item.variantId);
      url.searchParams.set('province', state.province); link.href = url.href;
      box.dataset.handle = item.handle;
    });
  }
  var RENDER_GATE_MS = 2500;
  function render(state) {
    if (!current(state)) return;
    // Show everything at once when the check is fast; only fall back to
    // progressive cards if it is still running after RENDER_GATE_MS.
    var waited = Date.now() - (state.started || 0);
    if (!shown(state) && !state.error && !state.limited && state.started && waited < RENDER_GATE_MS) {
      if (!state.gateTimer) state.gateTimer = setTimeout(function () { state.gateTimer = null; render(state); }, RENDER_GATE_MS - waited + 20);
      state.count.textContent = 'Finding tires available in ' + (names[state.province] || state.province) + '\u2026';
      state.grid.setAttribute('aria-busy', 'true');
      return;
    }
    if (state.gateTimer) { clearTimeout(state.gateTimer); state.gateTimer = null; }
    var matching = state.pool.filter(matches), visible = matching.slice(0, state.target);
    renderPicks(state, matching); chipCounts(state);
    var signature = visible.map(function (record) { return record.handle; }).join('|');
    if (state.renderKey !== signature) {
      state.grid.replaceChildren();
      visible.forEach(function (record, index) {
        var node = record.node.cloneNode(true);
        if (index < 4) node.querySelectorAll('img').forEach(function (image) {
          image.loading = 'eager'; image.decoding = 'async';
        });
        state.grid.appendChild(node);
      });
      state.renderKey = signature;
    }
    var area = names[state.province] || state.province;
    state.count.textContent = state.error ? 'Full result count could not be verified. Retry loading results.'
      : state.limited ? 'Found ' + matching.length + ' verified matches in a limited search' + (matching.length > visible.length ? ' · ' + visible.length + ' shown' : '') + '. Add a tire size or brand to finish checking all results.'
      : !shown(state) ? (visible.length ? 'Showing ' + visible.length + ' verified product' + (visible.length === 1 ? '' : 's') + '. Checking remaining matches for ' + area + '…' : 'Counting matching products for ' + area + '…')
      : matching.length + ' product' + (matching.length === 1 ? '' : 's') + ' available in ' + area + (matching.length > visible.length ? ' · ' + visible.length + ' shown' : '') +
        (state.stockUnknown ? ' · live stock check unavailable, confirm at checkout' : state.partial ? ' · some results could not be checked' : '');
    var more = matching.length > state.target;
    state.button.textContent = more ? 'Load more' : state.error || (state.partial && !state.busy) ? 'Retry loading results' : 'Load more';
    state.button.hidden = !more && !state.error && !(state.partial && !state.busy);
    state.button.disabled = false;
    state.grid.setAttribute('aria-busy', String(!shown(state) && !visible.length && !state.error && !state.limited));
    state.grid.dataset.tntSearchState = state.error ? 'error' : state.limited ? 'limited' : shown(state) ? 'ready' : 'loading';
    state.grid.dataset.tntSearchError = state.errorReason || '';
    if (state.complete && !state.error && !state.partial) {
      var query = queryText();
      document.title = 'Search: ' + matching.length + ' result' + (matching.length === 1 ? '' : 's') +
        ' for "' + query + '"' + (titleSuffix ? ' \u2013 ' + titleSuffix : '');
    }
  }
  async function readPage(state, url) {
    if (!current(state)) return null;
    if (cache.has(url)) return cache.get(url);
    var controller = new AbortController(); (state.aborts || (state.aborts = [])).push(controller);
    var deadline = setTimeout(function () { controller.abort(); }, 20000);
    try {
      var response;
      for (var attempt = 0; attempt < 2; attempt++) {
        response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
        if (response.status !== 429 || attempt === 1) break;
        var retryAfter = response.headers && response.headers.get('Retry-After');
        var retryMs = retryAfter ? Number(retryAfter) * 1000 : 1500;
        if (!Number.isFinite(retryMs)) retryMs = Date.parse(retryAfter) - Date.now();
        if (!Number.isFinite(retryMs)) retryMs = 1500;
        await new Promise(function (resolve) { setTimeout(resolve, Math.max(500, Math.min(5000, retryMs))); });
        if (!current(state)) return null;
      }
      if (!response.ok) throw new Error('Search data could not be loaded.');
      var data = await response.json();
      if (!Number.isSafeInteger(data.total) || data.total < 0 || !Array.isArray(data.items)) throw new Error('Invalid search result data.');
      var scopePath = new URL(state.initialUrl).pathname;
      if (new URL(state.initialUrl).searchParams.get('view') === 'tnt-vendor-results') {
        var expectedVendor = new URL(state.initialUrl).searchParams.get('q');
        if (data.vendorScope !== expectedVendor || data.items.some(function (item) {
          return String(item.vendor || '').toLowerCase() !== expectedVendor.toLowerCase();
        })) throw new Error('The brand lookup was not preserved.');
      }
      if (/^\/collections\/all\/\d{5,8}$/.test(scopePath) && data.tagMissing === true &&
          data.sizeTag === null && data.total === 0 && data.items.length === 0 && !data.next) {
        data.sizeTag = scopePath.split('/').pop();
      }
      if (/^\/collections\/all\/\d{5,8}$/.test(scopePath) && data.sizeTag !== scopePath.split('/').pop()) {
        throw new Error('The numeric size tag lookup was not preserved.');
      }
      if (data.next) {
        var next = new URL(data.next, url);
        if (next.origin !== location.origin || next.pathname !== scopePath) throw new Error('Unexpected pagination link.');
        next.searchParams.set('view', new URL(state.initialUrl).searchParams.get('view') || 'tnt-results'); next.searchParams.set('type', 'product');
        if (/^\/collections\/all\/\d{5,8}$/.test(scopePath)) next.searchParams.set('tnt_size_data', '2');
        if (new URL(state.initialUrl).searchParams.get('view') === 'tnt-vendor-results') {
          var vendorScope = new URL(state.initialUrl).searchParams.get('q');
          if (next.searchParams.get('q') !== vendorScope) throw new Error('The brand pagination filter was not preserved.');
          next.searchParams.set('tnt_vendor_data', '1');
        }
        data.next = next.href;
      }
      if (!current(state)) return null;
      if (cache.size >= 80) cache.delete(cache.keys().next().value);
      cache.set(url, data); return data;
    } finally { clearTimeout(deadline); }
  }
  // Parallel, fault-tolerant scan. Page 1 decides the page count; the rest of
  // the pages and their stock checks run concurrently (max 4 in flight). A
  // failing page or stock batch only drops those cards (and marks the result
  // partial so picks are withheld) instead of discarding the whole search.
  function buildRecords(state, data, pageIndex) {
    var q = queryText();
    return data.items.map(function (item, i) {
      if (!item || !item.handle || !Array.isArray(item.tags) || typeof item.html !== 'string' || !Number.isSafeInteger(item.price) || item.price < 0) return null;
      if (state.seen.has(item.handle)) return null;
      if (!window.TntSearchQuery.textMatches(item, q)) return null;
      var node = document.createElement('li'); node.className = 'grid__item'; node.innerHTML = item.html;
      node.dataset.tntPrice = String(item.price);
      if (!node.querySelector('.card-wrapper [data-tnt-destination-variant]')) return null;
      var tags = item.tags.map(function (tag) { return String(tag).toLowerCase(); });
      var record = Object.assign({}, item, { node: node, order: pageIndex * 1000 + i, tire: !tags.includes('wheel') &&
        (tags.includes('tire') || !!window.TntTirePicks.season(item.type, tags)) });
      return matchesQuery(record) ? record : null;
    }).filter(Boolean);
  }
  // Verified-card memo + in-flight sharing: a sort/facet change re-renders
  // from already-verified cards instead of re-asking the Finder, and two
  // overlapping scans never check the same card twice.
  var verifiedCards = new Map(), inflight = new Map(), VERIFIED_TTL = 5 * 60 * 1000;
  async function verify(state, records) {
    if (!records.length) return;
    var now = Date.now(), fresh = [], shared = [];
    records.forEach(function (record) {
      var key = state.province + '|' + record.handle, hit = verifiedCards.get(key);
      if (hit && now - hit.at < VERIFIED_TTL) { record.node = hit.node.cloneNode(true); record._card = null; }
      else if (inflight.has(key)) shared.push([record, inflight.get(key)]);
      else fresh.push(record);
    });
    var deadline, failed = new Set();
    var job = !fresh.length ? Promise.resolve() : Promise.race([
      window.TntProvinceStock.prepareCards(fresh.map(function (record) { return record.node; })),
      new Promise(function (_, reject) { deadline = setTimeout(function () { reject(new Error('Availability check timed out.')); }, 25000); })
    ]);
    fresh.forEach(function (record) {
      inflight.set(state.province + '|' + record.handle, job.then(function () { return record.node; }, function () { return null; }));
    });
    try { await job; }
    catch (error) { fresh.forEach(function (record) { failed.add(record); }); }
    finally {
      clearTimeout(deadline);
      fresh.forEach(function (record) { inflight.delete(state.province + '|' + record.handle); });
    }
    for (var i = 0; i < shared.length; i++) {
      var node = await shared[i][1];
      if (node) { shared[i][0].node = node.cloneNode(true); shared[i][0]._card = null; } else failed.add(shared[i][0]);
    }
    if (!current(state)) return;
    records.forEach(function (record) {
      if (failed.has(record)) { state.unchecked++; state.partial = true; return; }
      var card = record.node.querySelector('.card-wrapper'), data = card.dataset, outcome = data.tntDestinationState;
      if (outcome !== 'ready' && outcome !== 'unavailable') { state.unchecked++; state.partial = true; return; }
      if (fresh.indexOf(record) !== -1 && (outcome === 'unavailable' || data.tntStockKnown === 'true')) {
        verifiedCards.set(state.province + '|' + record.handle, { node: record.node.cloneNode(true), at: Date.now() });
      }
      if (outcome === 'ready' && data.tntDestinationExempt !== 'true' && !state.seen.has(record.handle)) {
        if (data.tntStockKnown !== 'true') state.stockUnknown = true;
        state.seen.add(record.handle); state.pool.push(record);
      }
    });
    state.pool.sort(function (a, b) { return a.order - b.order; });
  }
  async function readWithRetry(state, url) {
    try { return await readPage(state, url); }
    catch (error) {
      if (!current(state)) return null;
      await new Promise(function (resolve) { setTimeout(resolve, 600); });
      if (!current(state)) return null;
      cache.delete(url);
      return readPage(state, url);
    }
  }
  async function scan(state) {
    if (state.busy || !current(state)) return;
    if (state.error || state.partial) { cache.clear(); window.TntTirePicks.restart(state); }
    state.limited = false; state.partial = false; state.stockUnknown = false; state.unchecked = 0; state.missingPages = 0;
    state.busy = true; state.error = false; state.errorReason = ''; render(state);
    try {
      var first = await readWithRetry(state, state.initialUrl);
      if (!first || !current(state)) return;
      state.expected = first.total;
      var vendorView = new URL(state.initialUrl).searchParams.get('view') === 'tnt-vendor-results';
      var pages = first.next ? Math.max(2, Math.ceil(first.total / 50)) : 1;
      if (!vendorView && pages > 20) { pages = 20; state.limited = true; }
      var urls = [state.initialUrl];
      for (var p = 2; p <= pages; p++) {
        var u = new URL(first.next); u.searchParams.set('page', String(p)); urls.push(u.href);
      }
      // Shopify pages are cheap: request them all at once. The Finder stock API
      // processes one request at a time (max 50 items), so verify in display
      // order — page 1 cards render after a single stock round-trip.
      state.cands = []; state.priorityDone = false;
      var candSeen = new Set();
      var addPage = function (data, index) {
        state.visited.add(urls[index]);
        buildRecords(state, data, index).forEach(function (record) {
          if (!candSeen.has(record.handle)) { candSeen.add(record.handle); state.cands.push(record); }
        });
      };
      addPage(first, 0);
      // Stock-check page 1 while the remaining pages are still downloading.
      var early = state.cands.filter(staticMatch); if (!early.length) early = state.cands;
      early = early.slice(0, window.TntProvinceStock.batchSize || 50);
      early.forEach(function (r) { r._checked = true; });
      var earlyJob = verify(state, early).then(function () {
        early.forEach(function (r) { r._done = true; });
        if (current(state)) render(state);
      });
      await Promise.all([earlyJob].concat(urls.slice(1).map(function (url, i) {
        return readWithRetry(state, url).then(function (data) {
          if (!data) { state.missingPages++; state.partial = true; return; }
          if (current(state)) addPage(data, i + 1);
        }, function () { state.missingPages++; state.partial = true; });
      })));
      if (!current(state)) return;
      state.cands.sort(function (a, b) { return a.order - b.order; });
      // Pressed-chip tires first, in display order, 50 per Finder request;
      // the rest of the size is checked in the background afterwards.
      while (current(state)) {
        var todo = state.cands.filter(function (r) { return !r._checked; });
        if (!todo.length) break;
        var priority = todo.filter(staticMatch);
        var batch = (priority.length ? priority : todo).slice(0, window.TntProvinceStock.batchSize || 50);
        batch.forEach(function (r) { r._checked = true; });
        await verify(state, batch);
        batch.forEach(function (r) { r._done = true; });
        if (!current(state)) return;
        state.priorityDone = !state.cands.some(function (r) { return !r._done && staticMatch(r); });
        render(state);
      }
      if (current(state)) { state.next = null; state.complete = !state.limited; }
    } catch (error) {
      if (current(state)) {
        (state.aborts || []).forEach(function (c) { c.abort(); });
        state.error = true;
        state.errorReason = error.message || 'Search request failed.';
      }
    }
    finally { if (current(state)) { state.busy = false; render(state); relaxIfEmpty(state); } }
  }
  // A size + brand/model query with nothing available falls back to every
  // tire in that size (with a note) instead of a dead-end "0 products".
  function relaxIfEmpty(state) {
    try {
      if (!state.complete || state.error || state.partial || state.stockUnknown) return;
      if (state.pool.some(matchesQuery)) return;
      var u = new URL(location.href);
      if (u.searchParams.get('tnt_relaxed')) return;
      var it = window.TntSearchQuery.intent(queryText());
      if (!it.sizes.length || !it.rest) return;
      var relaxed = it.canonical.replace(it.rest, '').replace(/\s+/g, ' ').trim();
      if (!relaxed || relaxed === it.canonical) return;
      u.searchParams.set('q', relaxed); u.searchParams.set('tnt_relaxed', it.rest); u.searchParams.delete('page');
      location.replace(u.href);
    } catch (e) {}
  }
  function relaxedNotice(list) {
    var u = new URL(location.href), missing = u.searchParams.get('tnt_relaxed');
    var note = document.getElementById('tnt-relaxed-note');
    if (!missing) { if (note) note.remove(); return; }
    if (!note) { note = document.createElement('p'); note.id = 'tnt-relaxed-note'; note.setAttribute('role', 'status');
      note.style.cssText = 'margin:1rem 0;padding:.9rem 1.2rem;border-left:4px solid #154e49;background:#f1f5f4;color:#17332f'; list.before(note); }
    note.textContent = 'Nothing matching \u201c' + missing + '\u201d is available in ' + (u.searchParams.get('q') || 'that size') + ' right now \u2014 showing every tire in that size instead.';
  }
  function start() {
    var core = window.TntProvinceStock, list = grid();
    if (!core) return;
    mountChips();
    if (!core.selectedProvince()) return;
    if (!list) {
      var container = document.getElementById('ProductGridContainer');
      if (!container) return;
      list = document.createElement('ul'); list.id = 'product-grid'; list.className = 'grid product-grid grid--2-col-tablet-down grid--4-col-desktop'; list.setAttribute('role', 'list');
      container.replaceChildren(list);
    }
    syncLinks(); updateChips();
    var url = queryURL().href, province = core.selectedProvince();
    if (active && active.grid === list && active.key === url && active.province === province) return;
    if (active && active.aborts) active.aborts.forEach(function (c) { c.abort(); });
    // Server/facet-rendered cards are replaced by verified cards; remove them
    // before the province-stock observer spends Finder requests checking them.
    if (!active || active.grid !== list) list.replaceChildren();
    if (active && active.controls.isConnected) active.controls.remove();
    var count = document.getElementById('tnt-destination-count');
    if (!count) { count = document.createElement('p'); count.id = 'tnt-destination-count'; count.setAttribute('role', 'status'); list.before(count); }
    relaxedNotice(count);
    var pagination = document.createElement('div'); pagination.className = 'tnt-destination-pagination';
    var button = document.createElement('button'); button.type = 'button'; button.className = 'button button--secondary'; pagination.appendChild(button); list.after(pagination);
    var state = { started: Date.now(), key: url, province: province, grid: list, count: count, controls: pagination, button: button,
      initialUrl: url, next: url, expected: null, target: 24, pool: [], candidates: new Set(), seen: new Set(), visited: new Set(), complete: false, error: false, limited: false, busy: false, renderKey: null,
      rules: null, rulesError: false, catalogRetries: 0 };
    active = state;
    document.querySelectorAll('#ProductGridContainer .pagination-wrapper').forEach(function (node) { node.hidden = true; });
    button.addEventListener('click', function () {
      if (state.pool.filter(matches).length > state.target) { state.target += 24; render(state); }
      else if (state.error || state.partial) scan(state);
    });
    var row = document.getElementById('tnt-verified-picks');
    if (row) fetch(row.dataset.tntRebateRules, { credentials: 'same-origin' })
      .then(function (res) { if (!res.ok) throw new Error('Rebate configuration unavailable'); return res.json(); })
      .then(function (rules) {
        if (!Array.isArray(rules.programs) || !Array.isArray(rules.premiumBrands) || rules.programs.some(function (p) {
          return typeof p.brand !== 'string' || !Number.isSafeInteger(p.cents) || p.cents < 0 ||
            !/^\d{4}-\d{2}-\d{2}$/.test(p.start) || !/^\d{4}-\d{2}-\d{2}$/.test(p.end) ||
            !(p.models === '*' || Array.isArray(p.models));
        })) throw new Error('Invalid rebate configuration');
        state.rules = rules; if (current(state)) render(state);
      }).catch(function () { state.rulesError = true; if (current(state)) render(state); });
    scan(state);
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(start, 0); }
  window.TntSearchResults = { owns: function (node) { return !!active && !!node && (node === active.grid || node.contains(active.grid)); },
    stats: function () { return { verifiedCached: verifiedCards.size, pool: active ? active.pool.length : 0, partial: !!(active && active.partial), unchecked: active ? active.unchecked : 0 }; } };
  window.TntDestinationResults = window.TntSearchResults;
  document.addEventListener('tnt:provinceChanged', schedule);
  window.addEventListener('popstate', function () {
    var p = new URL(location.href).searchParams;
    var value = p.get('tnt_season');
    filters.season = seasons.concat(['winter']).includes(value) ? value : value === 'all' ? null : window.TntSearchQuery.seasonFromQuery(p.get('q') || '');
    toggles.forEach(function (entry) { filters[entry[0]] = p.get('tnt_' + entry[0]) === '1'; });
    updateChips(); if (active) { active.renderKey = null; render(active); } schedule();
  });
  new MutationObserver(function () {
    if (!document) return;
    if (!active || active.grid !== grid() || active.key !== queryURL().href) schedule();
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
})();
